module.exports = __webpack_public_path__ + "img/banner.aef31d91.png";